import { App } from '@capacitor/app';
import { useIonRouter, modalController } from '#imports';

export default defineNuxtPlugin(async () => {
  const platformStore = usePlatformStore();
  const deepLinkStore = useDeepLinkStore();
  const router = useRouting();
  const ionRouter = useIonRouter();

  if (platformStore.isMobile) {
  // Listener for handling deep links on Android and iOS
    App.addListener('appUrlOpen', async (data) => {
      const deepLinkUrl = new URL(data.url);

      function setDeepLinkDestination(destination: string) {
        if (router.route.path == '/') {
          deepLinkStore.destination = destination;
        } else {
          if (destination.startsWith('/')) {
            router.replace(destination, true);
          } else {
            ionRouter.push({ hash: '#messages' });
          }
        }
      }

      async function dismissAllModals() {
        let topModal = await modalController.getTop();

        while (topModal) {
          const modalClosed = await topModal.dismiss();

          // If the user chose to decline closing a modal, stop here
          if (!modalClosed) {
            return false;
          }

          topModal = await modalController.getTop();
        }

        return true;
      }

      switch (deepLinkUrl.pathname) {
        case '/OpenPage/TimeRegistration':
          if (!await dismissAllModals()) {
            return;
          }

          setDeepLinkDestination('/hourregistrations' + deepLinkUrl.search);

          break;
        case '/OpenPage/Messages':
          setDeepLinkDestination('#messages' + deepLinkUrl.search);
            
          break;

        case '/OpenPage/Projects':
          if (deepLinkUrl.searchParams.has('projectId') && deepLinkUrl.searchParams.has('worksheetId')) {
            if (!await dismissAllModals()) {
              return;
            }

            const projectId = deepLinkUrl.searchParams.get('projectId');
            const worksheetId = deepLinkUrl.searchParams.get('worksheetId');
            setDeepLinkDestination(`/projects/${projectId}/worksheets/${worksheetId}`);
          }
    
          break;
        case 'OpenPage/Event':

          break;
        default:
          break;
      }
    });
  }
});